<template>
  <div>
    <h2>
      Tracking Configuration
    </h2>
    <el-form
      ref="form"
      v-loading="isSaving"
    >
      <el-form-item label="Supports GPS Tracking">
        <el-switch v-model="formData.carrier_supports_gps_tracking" />
      </el-form-item>
      <el-form-item label="Supports Run Sheets">
        <el-switch v-model="formData.carrier_supports_run_sheets" />
      </el-form-item>
      <el-form-item label="OpenFreight Should Generate POD From Signature">
        <el-switch v-model="formData.carrier_pod_type" />
      </el-form-item>
      <el-form-item label="Supports Item Level Tracking">
        <el-switch v-model="formData.supports_item_tracking" />
      </el-form-item>
      <el-form-item label="Use POD as Delivery Scan">
        <el-switch v-model="formData.carrier_tracking_pod_is_delivery_scan" />
      </el-form-item>
      <el-form-item label="Tracking Link (Enquiry Page)">
        <el-input v-model="formData.carrier_tracking_link" />
      </el-form-item>
      <el-form-item label="Import Template">
        <el-input v-model="formData.tracking_import_template" />
      </el-form-item>
      <el-form-item label="Transform Template">
        <el-input v-model="formData.tracking_transformer_template" />
      </el-form-item>
      <el-form-item label="S/FTP Connection">
        <el-select
          v-model="formData.tracking_connection"
          :loading="loading"
          value-key="long"
          class="w-100"
        >
          <el-option
            v-for="connection in connections"
            :key="connection.id"
            :label="getConnectionName(connection)"
            :value="connection"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Notes">
        <el-input
          v-model="formData.carrier_tracking_notes"
          type="textarea"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      loading: true,
      connections: []
    }
  },
  created () {
    this
      .$sdk
      .connection
      .list(request => {
        request.limit = 100
      })
      .then(connections => { this.connections = connections })
      .finally(() => { this.loading = false })
  },
  methods: {
    getConnectionName (connection) {
      return `${connection.display_name} (${connection.username}@${connection.host})`
    }
  }
}
</script>
